<template>
	<header-block title="#Tagged Transactions"></header-block>
	<CustomerLoadWait :customer="customerTags" />
	<!-- <v-expansion-panels variant="accordion" elevation="1">
		<v-expansion-panel>
			<v-expansion-panel-title>
				<v-row class="titleRow" style="color: var(--text-color);">
					<v-col cols="8">
						<v-icon icon="mdi-information" /> What is this?
					</v-col>
				</v-row>
			</v-expansion-panel-title>
			<v-expansion-panel-text>
				<div style="padding: 20px;">

					<p>Ever wish you could easily see how much you're spending on specific things, like that awesome weekend getaway or your home renovation project? 
						Well, creating your own #tags for your transactions is like giving each purchase a special label. 
						This makes it super simple to see exactly how much that trip or project actually cost you, helping you stay on top of your budget!</p>
				</div>
			</v-expansion-panel-text>
		</v-expansion-panel>
	</v-expansion-panels> -->

	<InfoPanel 
		:icon="require('@/assets/Frame.png')" 
		title="#Spending, Your Way" 
		subtitle="Ever wish you could easily see how much you're spending on specific things, like that awesome weekend getaway or your home renovation project? Custom #tags allow you to do just that." 
	/>

	<p class="mt-4 centered" v-if="customerTags && customerTags.length == 0">You have not added any #tags yet, head over to a transaction's details and add your own now!</p>
	
	<transition>
		<div v-if="customerTags" class="mt-4" style="margin-left: -15px; margin-right: -15px;">
			<v-expansion-panels color="#ffffff" variant="popout" elevation="0">
				<v-expansion-panel v-for="t in customerTags" :key="t.id">
					<v-expansion-panel-title>
						<v-row class="titleRow">
							<v-col>
								#{{ t.tag }}
							</v-col>
							<v-col class="right">
								{{ formatter.format(t.total) }}
							</v-col>
						</v-row>
					</v-expansion-panel-title>
					<v-expansion-panel-text>
						<TransactionsList :showDateTotal="true" :transactions="t.groupedTransactions" :formatter="formatter" emptyDescription="Go forth and #tag!" />
					</v-expansion-panel-text>
				</v-expansion-panel>
			</v-expansion-panels>
		</div>
	</transition>
</template>

<script>
import Services from '../mixins/Services';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import TransactionsList from './elements/TransactionsList.vue';
import InfoPanel from './elements/InfoPanel.vue';

export default {
	mixins: [Services],
	components: {CustomerLoadWait, HeaderBlock, TransactionsList, InfoPanel},
	data() {
		return {
			customerTags: null
		}
	},
	methods: {
		onLoad: async function() {
			this._getCustomer(() => {
				this._getCustomerTags((result) => {
					this.customerTags = result;
					this.customerTags.forEach((tag) => {
						tag.total = 0;
						this._getTransactionsForCustomerTag(tag.id, (gt) => {
							tag.groupedTransactions = gt;
							tag.groupedTransactions.forEach((g) => {
								g.forEach((t) => {
									tag.total += t.amount;
								});
							});
						});
					});
				});
			});
		}
	},
	mounted: function () {
		this.onLoad();
	},
}
</script>

<style scoped>

.titleRow {
	.v-col {
		font-size: 13px !important;
		white-space: nowrap;
	}
}

:deep(.v-expansion-panel-text__wrapper){
	padding:0px !important;
}

</style>
